// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mini-tour {
  position: relative;
  overflow: hidden;
}
mini-tour .mini-tour {
  max-width: 100%;
  overflow: hidden;
  border-radius: var(--border-radius);
  color: var(--motes-white);
  transition: 0.2s;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
}
mini-tour .mini-tour .tour-content {
  opacity: 1;
  transition: 0.2s;
  background-color: var(--motes-dark-gray);
  border-radius: var(--border-radius);
  overflow: hidden;
  position: relative;
}
mini-tour .mini-tour .tour-content:hover {
  background-color: var(--motes-darker-gray);
}
mini-tour .mini-tour .tour-content .loading-navigation {
  position: absolute;
  top: 0px;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  aspect-ratio: 16/9;
  padding-top: 2px;
}
mini-tour .mini-tour .tour-content .loading-navigation::before {
  content: "";
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transform-origin: 0% 100%;
  animation: loadingUp 250ms;
}
mini-tour .mini-tour .tour-content .loading-navigation p {
  display: none;
}
@keyframes loadingUp {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}
mini-tour .mini-tour .tour-content light-image .image-container {
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}
mini-tour .mini-tour .tour-content .info-text {
  padding: var(--medium-spacing);
  box-sizing: border-box;
}
mini-tour .mini-tour .tour-content .info-text h4, mini-tour .mini-tour .tour-content .info-text .preview {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
mini-tour .mini-tour .tour-content .info-text h4 {
  font-size: 16px;
  line-height: 23px;
  -webkit-line-clamp: 1;
}
mini-tour .mini-tour .tour-content .info-text .preview {
  -webkit-line-clamp: 2;
  height: 40px;
  margin-bottom: var(--small-spacing);
  white-space: normal;
}
mini-tour .mini-tour .tour-content .info-text .summary {
  display: grid;
  column-gap: var(--medium-spacing);
  grid-template-columns: max-content max-content 1fr;
}
mini-tour .mini-tour .tour-content .info-text .summary .translations {
  display: flex;
  justify-content: flex-end;
  color: var(--primary-color);
}
mini-tour .mini-tour.loading {
  background: linear-gradient(-45deg, var(--motes-black), var(--motes-dark-gray));
  background-size: 400% 400%;
  animation: gradient 2s ease infinite;
}
mini-tour .mini-tour.loading .tour-content {
  background-color: transparent;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/mini-tour/mini-tour.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACR;AACQ;EACI,UAAA;EACA,gBAAA;EACA,wCAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AACZ;AACY;EACI,0CAAA;AAChB;AAEY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAAhB;AAEgB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,0BAAA;AAApB;AAGgB;EACI,aAAA;AADpB;AAKY;EACI;IACI,oBAAA;EAHlB;EAKc;IACI,oBAAA;EAHlB;AACF;AAMY;EACI,4DAAA;AAJhB;AAOY;EACI,8BAAA;EACA,sBAAA;AALhB;AAOgB;EACI,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AALpB;AAQgB;EACI,eAAA;EACA,iBAAA;EACA,qBAAA;AANpB;AASgB;EACI,qBAAA;EACA,YAAA;EACA,mCAAA;EACA,mBAAA;AAPpB;AAUgB;EACI,aAAA;EACA,iCAAA;EACA,kDAAA;AARpB;AAUoB;EACI,aAAA;EACA,yBAAA;EACA,2BAAA;AARxB;AAeQ;EACI,+EAAA;EACA,0BAAA;EACA,oCAAA;AAbZ;AAeY;EACI,6BAAA;AAbhB;AAiBQ;EACI;IACI,2BAAA;EAfd;EAiBU;IACI,6BAAA;EAfd;EAiBU;IACI,2BAAA;EAfd;AACF","sourcesContent":["mini-tour {\n    position: relative;\n    overflow: hidden;\n\n    .mini-tour {\n        max-width: 100%;\n        overflow: hidden;\n        border-radius: var(--border-radius);\n        color: var(--motes-white);\n        transition: 0.2s;\n        font-size: 13px;\n        line-height: 20px;\n        cursor: pointer;\n    \n        .tour-content {\n            opacity: 1;\n            transition: 0.2s;\n            background-color: var(--motes-dark-gray);\n            border-radius: var(--border-radius);\n            overflow: hidden;\n            position: relative;\n\n            &:hover {\n                background-color: var(--motes-darker-gray);\n            }\n\n            .loading-navigation {\n                position: absolute;\n                top: 0px;\n                width: 100%;\n                display: flex;\n                align-content: center;\n                justify-content: center;\n                align-items: center;\n                aspect-ratio: 16/9;\n                padding-top: 2px;\n\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    top: 0px;\n                    width: 100%;\n                    height: 100%;\n                    background-color: rgba(0, 0, 0, 0.5);\n                    transform-origin: 0% 100%;\n                    animation: loadingUp 250ms;\n                }\n\n                p {\n                    display: none;\n                }\n            }\n\n            @keyframes loadingUp {\n                0% {\n                    transform: scaleY(0);\n                }\n                100% {\n                    transform: scaleY(1);\n                }\n            }\n\n            light-image .image-container {\n                border-radius: var(--border-radius) var(--border-radius) 0 0; // Necessary for Safari\n            }\n    \n            .info-text {\n                padding: var(--medium-spacing);\n                box-sizing: border-box;\n        \n                h4, .preview {\n                    display: -webkit-box;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                }\n        \n                h4 {\n                    font-size: 16px;\n                    line-height: 23px;\n                    -webkit-line-clamp: 1;\n                }\n        \n                .preview {\n                    -webkit-line-clamp: 2;\n                    height: 40px;\n                    margin-bottom: var(--small-spacing);\n                    white-space: normal;\n                }\n        \n                .summary {\n                    display: grid;\n                    column-gap: var(--medium-spacing);\n                    grid-template-columns: max-content max-content 1fr;\n        \n                    .translations {\n                        display: flex;\n                        justify-content: flex-end;\n                        color: var(--primary-color);\n                    }\n                }\n            }\n        }\n        \n        // Pulsating background while tour is loading\n        &.loading {\n            background: linear-gradient(-45deg, var(--motes-black), var(--motes-dark-gray));\n            background-size: 400% 400%;\n            animation: gradient 2s ease infinite;\n    \n            .tour-content {\n                background-color: transparent;\n            }\n        }\n    \n        @keyframes gradient {\n            0% {\n                background-position: 0% 50%;\n            }\n            50% {\n                background-position: 100% 50%;\n            }\n            100% {\n                background-position: 0% 50%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
